import categorySlugsEN from '../../algolia-category-slugs-en.json';
import categorySlugsFR from '../../algolia-category-slugs-fr.json';
import { slugify } from '@utils/url';

// Compute these dicts backwards, so we get name -> slug
const categoryNamesEN = Object.fromEntries(
  Object.entries(categorySlugsEN).map(([key, value]) => [value, key])
);
const categoryNamesFR = Object.fromEntries(
  Object.entries(categorySlugsFR).map(([key, value]) => [value, key])
);

export const getCategorySlugFromName = (
  name: string,
  locale = 'en'
): string => {
  const catDict: { [key: string]: string } =
    locale === 'en' ? categoryNamesEN : categoryNamesFR;

  const trimmedName = name.trim();
  return catDict[trimmedName] || slugify(trimmedName);
};
